import React, { Component } from 'react';

class Ads extends Component {
    componentDidMount () {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    
    render () {
        return (
          <div className='ad'>
            <ins className='adsbygoogle'
              style={{ display: 'block', textAlign: 'center', marginTop: '10px' }}
              data-ad-client='ca-pub-7728654186209421'
              data-ad-format='auto' />
          </div>
        );
    }
}

export default Ads;